import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { catchError, EMPTY, tap } from 'rxjs';
import { ModalQrScannerComponent } from '../modal-qr-scanner/modal-qr-scanner.component';
import { ScreeningState } from '../../../store/screening/screening.state';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CdkStepper } from '@angular/cdk/stepper';
import { ToastrService } from 'ngx-toastr';
import { TvfRequestsService } from '../../../tvf/services/tvf-requests.service';
import { Store } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';

import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-imei-validator',
  templateUrl: './imei-validator.component.html',
  styleUrls: ['./imei-validator.component.sass'],
})
export class ImeiValidatorComponent implements OnInit {
  @ViewChild('inputImei') searchElement: ElementRef;

  isRepair: boolean = false;
  form: FormGroup = new FormGroup({
    idTrade: new FormControl(''),
    confirmImei: new FormControl(''),
    imeiValidated: new FormControl(''),
  });

  constructor(
    public dialog: MatDialog,
    public _requestService: TvfRequestsService,
    private _toastrService: ToastrService,
    private _store: Store,
    private _route: ActivatedRoute,
    private _fb: FormBuilder,
    private _router: Router
  ) {}

  public imeiValue: string;
  idTrade: string;

  get imeiFieldValid(): boolean {
    return this.searchElement?.nativeElement?.validity?.valid;
  }

  ngOnInit(): void {
    const state = this._store.selectSnapshot(ScreeningState);
    this.idTrade = state.idTrade;
    this.isRepair = !!state.isRepair;

    this.form = this._fb.group({
      idTrade: [this.idTrade, Validators.required],
      confirmImei: ['', Validators.required],
      imeiValidated: ['', Validators.requiredTrue],
    });

    this.form.get('confirmImei').valueChanges.subscribe((_) => {
      this.form.get('imeiValidated').patchValue(false);
    });
  }

  readQrCode() {
    const dialogConfig = {
      width: '100%',
      maxWidth: '650px',
    };

    this.dialog.open(ModalQrScannerComponent, dialogConfig);
  }

  isMatch() {
    const confimImei: string = this.form.get('confirmImei').value;
    this.form.get('confirmImei').markAsTouched();
    if (confimImei) {
      this._requestService
        .isImeiBipedAvailable(confimImei, this.idTrade)
        .pipe(
          tap(() => {
            this.form.get('imeiValidated').patchValue(true);
          }),
          catchError((error) => {
            this.form.get('confirmImei').setErrors({ serverError: error.message });
            this.form.get('imeiValidated').patchValue(false);
            return EMPTY;
          })
        )
        .subscribe();
    }
  }

  sendImei() {
    const imei = this.form.get('confirmImei').value;
    this._requestService
      .sendImei(imei, this.idTrade)
      .pipe(
        tap(() => {
          const { isRepair } = this._store.selectSnapshot(ScreeningState);
          const nextPath = isRepair ? 'checklist' : 'decision';

          this._router.navigate([`../${nextPath}`], { relativeTo: this._route });
        }),
        catchError(() => {
          this._toastrService.error('Não foi possível enviar o Imei.');
          return EMPTY;
        })
      )
      .subscribe();
  }
}
